import { render, staticRenderFns } from "./ExamAttributeGroup.vue?vue&type=template&id=bd19cb1c&scoped=true&"
import script from "./ExamAttributeGroup.vue?vue&type=script&lang=ts&"
export * from "./ExamAttributeGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ExamAttributeGroup.vue?vue&type=style&index=0&id=bd19cb1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd19cb1c",
  null
  
)

export default component.exports